import React from "react";

const ContainerLoading = ({ galleryLoader, containerClass }) => {
  return (
    <div
      className={`${
        galleryLoader ? "detail-loading-gallery" : "detail-loading-div"
      } ${containerClass}`}
      id="loader"
    >
      <img
        className="detail-loading-image"
        src={`${process.env.REACT_APP_STYLES_PATH}loader.gif`}
        alt=""
      />
    </div>
  );
};

export default ContainerLoading;
